import DataLoader from "dataloader"
import { useSuspenseQuery } from "@tanstack/react-query"
import { get } from "../typed-client/get"

const loader = new DataLoader(
  async (keys: readonly number[]) => {
    const results = await get("/api/Person/GetPersonDataContactPermissions", {
      personIds: [...keys],
    })
    return keys.map((key) => results[key])
  },
  { batchScheduleFn: (callback) => setTimeout(callback, 100) }
)

export function useBatchedPersonContactDataPermissions(key: number) {
  return useSuspenseQuery({
    queryKey: ["PersonContactDataPermission", key],
    queryFn: () => loader.load(key),
  })
}
